@if (!isLangLoaded || isNavigationInProgress) {
  <app-loader [isOverlay]="isNavigationInProgress" />
}

@if (isLangLoaded) {
  <div class="page-wrapper">
    <div class="menu-container" [class.menu-container--white]="isWhiteBg">
      <div class="menu-content">
        <main>
          @if (bannerId) {
            <global-bloomreach-banner-container
              [id]="bannerId"
              />
          }
          @if (!isMobile) {
            <app-old-browser />
          }
          @if (showHeader) {
            <pac-header
              [isAuthorizedHeaderLocked]="isAuthorizedHeaderLocked"
              [isHeaderNavigationLocked]="isHeaderNavigationLocked"
              />
          }
          <noscript>
            {{ 'error.title.no-js' | translate }}
          </noscript>
          <router-outlet />
        </main>
      </div>
    </div>
  </div>
}
